module.exports = __webpack_public_path__ + "img/card.421a4c47.svg";